		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ChecklistTaskService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('ChecklistTask');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.ChecklistTask[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForChecklist(id: System.Guid) : Observable<TooBig4Car.Logic.ChecklistTask[]> {
		return this.myBaseService.loadAll(this.url +'/List/' + id);
	}
	save(tempItem: TooBig4Car.Logic.ChecklistTask) : Observable<TooBig4Car.Logic.ChecklistTask> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.ChecklistTask> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.ChecklistTask>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<TooBig4Car.Logic.ChecklistTask[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}
				
